// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TaskBoardIcon from './data'

export default function TaskBoardIconFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TaskBoardIcon">
      <TaskBoardIcon {...props}>
        {children}
      </TaskBoardIcon>
    </Flow>
  )
}
